import React, { useEffect, useState } from "react";

import '@react-pdf-viewer/core/lib/styles/index.css';
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { searchPlugin } from '@react-pdf-viewer/search';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { CgChevronDown, CgChevronUp, CgSearch, CgSoftwareDownload, CgZoomIn, CgZoomOut } from "react-icons/cg";

import "./style.scss";
import { useRef } from "react";
import { FaChevronDown, FaChevronUp, FaXmark } from "react-icons/fa6";
import { FaSearch, FaTools } from "react-icons/fa";
import SpinLoader from "../../loader/loader";

const PDFZoom = () => {
    const [zoomValue, setzoomValue] = useState('');

    const handleZoomIn = () => {
        const element = document.querySelector('[aria-describedby="rpv-core__tooltip-body-zoom-in"]');
        const button = element?.children[0];
        button?.click();
        setPdfZoomValue();
    }

    const handleZoomOut = () => {
        const element = document.querySelector('[aria-describedby="rpv-core__tooltip-body-zoom-out"]');
        const button = element?.children[0];
        button?.click();
        setPdfZoomValue();
    }

    const handlePDFZoom = () => {
        const btn = document.querySelector('[aria-label="Zoom document"]');
        btn?.click();
        setTimeout(() => {
            const pdfZoom = document.getElementById('rpv-core__popover-body-inner-zoom');
            pdfZoom?.addEventListener('click', () => {
                setPdfZoomValue();
            })
        }, 100);
    }

    const setPdfZoomValue = () => {
        setTimeout(() => {
            const zoomValueTag = document.querySelector('.rpv-zoom__popover-target');
            const value = zoomValueTag?.children[0]?.innerHTML;
            setzoomValue(value);
        }, 100);
    }

    useEffect(() => {
        setPdfZoomValue();
    }, [])

    return (
        <div className="rpv-toolbar-zoom-section">
            <div className="toolbar-icon" onClick={() => handleZoomIn()}><CgZoomIn /></div>
            <div className="pdf-zoom-value" onClick={() => handlePDFZoom()}>{zoomValue || "90%"}</div>
            <div className="toolbar-icon" onClick={() => handleZoomOut()}><CgZoomOut /></div>
        </div>
    )
}

const PDFDownload = () => {
    const handleDownload = () => {
        const element = document.querySelector('[aria-describedby="rpv-core__tooltip-body-get-file"]');
        const button = element?.children[0];
        button?.click();
    }

    return (
        <div className="rpv-toolbar-download-section">
            <div className="toolbar-icon" onClick={() => handleDownload()}><CgSoftwareDownload /></div>
        </div>
    )
}

const SearchModal = ({ setSearchTerm, handleSearchModal, searchPluginInstance }) => {
    const [searchValue, setSearchValue] = useState("")

    const findMatch = () => {
        setSearchTerm(searchValue);
        searchPluginInstance.clearHighlights();
        searchPluginInstance.highlight(searchValue);
    }

    const handleSearch = (e) => {
        setSearchValue(e?.target?.value)
    };

    const handleNextMatch = () => {
        searchPluginInstance.jumpToNextMatch();
    };

    const handlePreviousMatch = () => {
        searchPluginInstance.jumpToPreviousMatch();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            findMatch()
        }
    }

    return (
        <div className="rpv-toolbar-search-modal">
            <div className="search-modal-contents">
                <div className="search-modal-header">
                    <div className="search-modal-title">PDF Search</div>
                    <div className="search-modal-close-icon" onClick={handleSearchModal}><FaXmark className="toolbar-icon" /></div>
                </div>
                <div className="search-modal-body">
                    <div className="search-input-section">
                        <div className="search-input-wrapper">
                            <input
                                className="search-input"
                                type="text"
                                placeholder="Search"
                                value={searchValue}
                                onChange={(e) => handleSearch(e)}
                                onKeyDown={(e) => handleKeyDown(e)}
                            />
                            <div className="search-icon" onClick={() => findMatch()}><FaSearch className="toolbar-icon" /></div>
                        </div>
                        <div className="search-navigator">
                            <div className="navigator-icon" onClick={() => handlePreviousMatch()}><FaChevronUp className="toolbar-icon" /></div>
                            <div className="navigator-icon" onClick={() => handleNextMatch()}><FaChevronDown className="toolbar-icon" /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const PDFSearchSection = ({ handleSearchModal }) => {
    return (
        <div className="rpv-toolbar-search-section">
            <div className="toolbar-icon" onClick={() => handleSearchModal()}><CgSearch /></div>
        </div>
    )
}

const PDFPagination = ({ paginationDetails, setjumpToPage }) => {
    const [page, setPage] = useState(1)

    const handlePrevPage = () => {
        const element = document.querySelector('[aria-describedby="rpv-core__tooltip-body-page-navigation-previous"]');
        const button = element?.children[0];
        button?.click();
    }

    const handleNextPage = () => {
        const element = document.querySelector('[aria-describedby="rpv-core__tooltip-body-page-navigation-next"]');
        const button = element?.children[0];
        button?.click();
    }

    const handleJumpToPage = (e) => {
        const selectedPage = e?.target?.value;

        if (!(selectedPage < 0) && !(selectedPage > paginationDetails?.numPages)) {
            setPage(selectedPage)
            setjumpToPage(selectedPage)
        }
    }

    useEffect(() => {
        setPage((Number(paginationDetails?.currentPage) + 1))
    }, [paginationDetails?.currentPage])

    return (
        <div className="rpv-toolbar-pagination-section">
            <div className="toolbar-icon prev-page" onClick={() => handlePrevPage()}><CgChevronUp /></div>
            <input value={page} type="number" className="jump-page-input" onChange={(e) => handleJumpToPage(e)} />
            <div className="available-pages">
                <span className="bar-icon">/</span>
                {paginationDetails?.numPages}
            </div>
            <div className="toolbar-icon next-page" onClick={() => handleNextPage()}><CgChevronDown /></div>
        </div>
    )
}

const Preview = ({ fileUrl, fullScreen, goToPage, restrictDownload }) => {
    const [defaultZoomValue, setDefaultZoomValue] = useState(0.9);
    const [showPdfViewer, setShowPdfViewer] = useState(true);
    const [pdfPagination, setPdfPagination] = useState({ currentPage: 0, numPages: 1 })
    const [jumpToPage, setjumpToPage] = useState(null)
    const [searchTerm, setSearchTerm] = useState(null)
    const [showToolBar, setShowToolBar] = useState(false)
    const [showToolBarContents, setShowToolBarContents] = useState(false)
    const [showSearchModal, setShowSearchModal] = useState(false)

    const pluginFunctionsRef = useRef(null);

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const searchPluginInstance = searchPlugin();

    const onDocumentLoad = () => {
        setShowToolBar(true)
        setShowToolBarContents(true)
    }

    const handlePageChange = (e) => {
        setPdfPagination({ currentPage: e?.currentPage, numPages: e?.doc?._pdfInfo?.numPages })
    }

    const handleMobileFilters = () => {
        setShowToolBarContents(!showToolBarContents)
    }

    const handleSearchModal = () => {
        setShowSearchModal(!showSearchModal)
        setSearchTerm(null)

        if (window.innerWidth <= 768) {
            setShowToolBarContents(false)
        }
    }

    const handleResize = () => {
        if (window.innerWidth <= 768) {
            setShowToolBarContents(false)
        } else {
            setShowToolBarContents(true)
        }
    }

    useEffect(() => {
        handleResize()
        window.addEventListener("resize", handleResize)
        return () => {
            window.removeEventListener("resize", handleResize) //Clean up
        }
    }, [])


    useEffect(() => {
        if (pluginFunctionsRef.current && jumpToPage) {
            pluginFunctionsRef.current.jumpToPage(jumpToPage - 1); // jumpToPage is 1-based, plugin is 0-based
        }

        setjumpToPage(null)
    }, [jumpToPage]);

    useEffect(() => {
        if (searchTerm) {
            searchPluginInstance.highlight(searchTerm);
            searchPluginInstance.Search();
        } else {
            searchPluginInstance.clearHighlights();
        }
    }, [searchTerm])

    useEffect(() => {
        if (fullScreen) {
            setDefaultZoomValue(1.5);
            setShowPdfViewer(false);
            setTimeout(() => {
                setShowPdfViewer(true);
            }, 0);
        } else {
            setDefaultZoomValue(0.8);
            setShowPdfViewer(false);
            setTimeout(() => {
                setShowPdfViewer(true);
            }, 0);
        }
    }, [fullScreen])


    useEffect(() => {
        if (goToPage && pluginFunctionsRef.current) {
            pluginFunctionsRef.current.jumpToPage(goToPage - 1); // jumpToPage is 1-based, plugin is 0-based
        }
    }, [goToPage, pluginFunctionsRef.current])

    return (
        <div className="pdf-file-preview-container">
            {/* Toolbar */}
            {showToolBar && (
                <div className="react-pdf-viewer-toolbar">
                    {showToolBarContents && (
                        <>
                            <div className="rpv-toolbar-section left-section">
                                <PDFZoom />
                            </div>
                            <div className="rpv-toolbar-section mid-section">
                                <PDFPagination paginationDetails={pdfPagination} setjumpToPage={setjumpToPage} />
                            </div>
                            <div className="rpv-toolbar-section right-seaction">
                                <PDFSearchSection handleSearchModal={handleSearchModal} />
                                {
                                // !restrictDownload && 
                                <PDFDownload />}
                            </div>
                        </>
                    )}
                    {showSearchModal && (
                        <SearchModal handleSearchModal={handleSearchModal} setSearchTerm={setSearchTerm} searchPluginInstance={searchPluginInstance} />
                    )}
                    <div className="mobile-toolbar-section" onClick={() => handleMobileFilters()}>
                        <FaTools className="toolbar-icon" />
                        <div className="break-line" />
                        <div className="toolbar-mobile-text">PDF Tools</div>
                        <div className="break-line" />
                        {showToolBarContents ? <FaChevronUp className="toolbar-icon" /> : <FaChevronDown className="toolbar-icon" />}
                    </div>
                </div>
            )}
            {/* Body */}
            <div className="pdf-body-section">
                {showPdfViewer && (
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                        <Viewer
                            onPageChange={(e) => handlePageChange(e)}
                            initialPage={jumpToPage !== null ? jumpToPage : 0}
                            defaultScale={defaultZoomValue}
                            onDocumentLoad={() => onDocumentLoad()}
                            fileUrl={fileUrl}
                            plugins={[
                                defaultLayoutPluginInstance,
                                searchPluginInstance,
                                {
                                    install: (pluginFunctions) => {
                                        pluginFunctionsRef.current = pluginFunctions;
                                    },
                                },
                            ]}
                            renderLoader={() => <SpinLoader />}
                        />
                    </Worker>
                )}
            </div>
        </div>
    )
}

export default Preview;

